import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] custom" }
const _hoisted_2 = { class: "flex xl:flex-row flex-col px-4 pt-4 gap-4 bg-[#23242A] text-white" }
const _hoisted_3 = { class: "rounded-[10px] pb-2 bg-[#2B2C32] w-full" }
const _hoisted_4 = { class: "text-[24px] font-semibold text-white px-4 pt-4" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "table w-full mt-6 pb-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "xl:w-[50%] w-full custom-right pb-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_add_employee = _resolveComponent("add-employee")!
  const _component_edit_employee = _resolveComponent("edit-employee")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([(_ctx.add || _ctx.edit)?'xl:w-[50%]':'w-full', "custom-left"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Employee List", -1)),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchData && _ctx.searchData(...args))),
                  class: "rounded bg-field-black align-top mr-2 border-0",
                  placeholder: "Search..."
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ]),
                (_ctx.can_manage_employees)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAdd && _ctx.openAdd(...args)), ["prevent"]))
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("span", null, [
                        _createElementVNode("svg", {
                          fill: "currentColor",
                          width: "32",
                          height: "32",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" })
                        ])
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
              : (_openBlock(), _createBlock(_component_table_lite, {
                  key: 1,
                  "is-slot-mode": true,
                  "has-checkbox": false,
                  class: _normalizeClass('block w-full admin-table admin-table-custom'),
                  rowClasses: row => row?row.id:null,
                  columns: _ctx.table.columns,
                  rows: _ctx.table.rows,
                  total: _ctx.table.totalRecords,
                  sortable: _ctx.table.sortable,
                  "page-size": _ctx.table.pagesize,
                  onDoSearch: _ctx.doSearch,
                  page: _ctx.table.page,
                  onRowClicked: _ctx.selectedRow,
                  pageOptions: _ctx.table.pageOptions,
                  messages: {
                                pagingInfo: 'Total: {2}',
                                pageSizeChangeLabel: 'Items per Page',
                                gotoPageLabel: 'Go to page',
                                noDataAvailable: 'No records found!',
                            }
                }, {
                  role: _withCtx((data) => [
                    (data?.value?.roles?.length>0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.value.roles[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["rowClasses", "columns", "rows", "total", "sortable", "page-size", "onDoSearch", "page", "onRowClicked", "pageOptions"]))
          ])
        ])
      ], 2),
      (_ctx.add || _ctx.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.add)
              ? (_openBlock(), _createBlock(_component_add_employee, {
                  key: 0,
                  onAdded: _ctx.closeAddAndGetData,
                  onClose: _ctx.closeAdd
                }, null, 8, ["onAdded", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.edit)
              ? (_openBlock(), _createBlock(_component_edit_employee, {
                  key: 1,
                  editItem: _ctx.editItem,
                  onEdited: _ctx.edited,
                  onClose: _ctx.closeEdit
                }, null, 8, ["editItem", "onEdited", "onClose"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}